<template>
  <div v-if="isLoading">
    <div class="spinner-wrapper">
      <div class="spinner">
        <div class="double-bounce1 purple-spinner"></div>
        <div class="double-bounce2 purple-spinner"></div>
      </div>
      <div class="spinner">
        <div class="double-bounce1 purple-spinner"></div>
        <div class="double-bounce2 purple-spinner"></div>
      </div>
      <div class="spinner">
        <div class="double-bounce1 purple-spinner"></div>
        <div class="double-bounce2 purple-spinner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paxel-loader',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    loading: {
      immediate: true,
      handler(neValue) {
        this.isLoading = neValue;
      },
    },
  },
  data() {
    return {
      isLoading: this.loading,
    };
  },
};
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  margin: 100px auto;
}
.spinner {
  width: 20px;
  height: 20px;
  margin-left: .1rem;
  margin-right: .1rem;
  position: relative;
}
.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  /*opacity: 0.6;*/
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: px-bounce 2.0s infinite ease-in-out;
  animation: px-bounce 2.0s infinite ease-in-out;
}
.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}
.purple-spinner {
  background-color: #5e51a1;
}
.yellow-spinner {
  background-color: #ffb003;
}
.red-spinner {
  background-color: #ff1e26;
}
@-webkit-keyframes px-bounce {
  0%,
  100% {
    -webkit-transform: scale(0.0)
  }
  50% {
    -webkit-transform: scale(1.0)
  }
}
@keyframes px-bounce {
  0%,
  100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>
